export const mimeTypes = {
  apng: "image/apng",
  avif: "image/avif",
  bmp: "image/bmp",
  btif: "image/prs.btif",
  cgm: "image/cgm",
  cmx: "image/x-cmx",
  djv: "image/vnd.djvu",
  djvu: "image/vnd.djvu",
  dwg: "image/vnd.dwg",
  dxf: "image/vnd.dxf",
  fbs: "image/vnd.fastbidsheet",
  fh: "image/x-freehand",
  fh4: "image/x-freehand",
  fh5: "image/x-freehand",
  fh7: "image/x-freehand",
  fhc: "image/x-freehand",
  fpx: "image/vnd.fpx",
  fst: "image/vnd.fst",
  g3: "image/g3fax",
  gif: "image/gif",
  ico: "image/vnd.microsoft.icon",
  ief: "image/ief",
  jfif: "image/jpeg",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  mdi: "image/vnd.ms-modi",
  mmr: "image/vnd.fujixerox.edmics-mmr",
  npx: "image/vnd.net-fpx",
  pbm: "image/x-portable-bitmap",
  pct: "image/x-pict",
  pcx: "image/x-pcx",
  pgm: "image/x-portable-graymap",
  pic: "image/x-pict",
  pjp: "image/jpeg",
  pjpeg: "image/jpeg",
  png: "image/png",
  pnm: "image/x-portable-anymap",
  ppm: "image/x-portable-pixmap",
  psd: "image/vnd.adobe.photoshop",
  ras: "image/x-cmu-raster",
  rgb: "image/x-rgb",
  rlc: "image/vnd.fujixerox.edmics-rlc",
  svg: "image/svg+xml",
  svgz: "image/svg+xml",
  tif: "image/tiff",
  tiff: "image/tiff",
  wbmp: "image/vnd.wap.wbmp",
  webp: "image/webp",
  xbm: "image/x-xbitmap",
  xif: "image/vnd.xiff",
  xpm: "image/x-xpixmap",
  xwd: "image/x-xwindowdump",
};
